<template lang="pug">
  div(:class="loadingClass")
    vue-shipping-method(
    :shipment="shipment",
    :shipping-charge="shippingCharge",
    :current-shipping-country="currentShippingCountry",
    :key="shipment._id + '_' + shippingCharge.shipping_method",
    :loading="loading",
    v-model="currentShippingMethod",
    v-for="shippingCharge in shippingCharges"
    )
</template>

<script>
  import shippingMethodComponent from './shipping_method.vue';

  export default {
    name: 'shipping_methods',

    components: {
      'vue-shipping-method': shippingMethodComponent
    },

    data() {
      return {
        loading: false
      };
    },

    props: {
      shipment: {
        type: Object,
        required: true
      }
    },

    computed: {
      loadingClass() {
        return {
          'c-loading': this.loading,
          'c-loading--opacity': this.loading
        };
      },

      wishlistId() {
        return this.$store.getters['cart/current']().wishlistId;
      },

      shippingCharges() {
        return this.shipment.shipping_charges;
      },

      currentShippingCountry() {
        return this.$store.getters['shippings/current'].country;
      },

      currentShippingMethod: {
        get() {
          return this.shippingCharges.find((shippingCharges) => {
            return shippingCharges.selected;
          }).shipping_method;
        },

        set(shippingMethod) {
          this.onChangeShippingMethod(shippingMethod);
        }
      }
    },

    methods: {
      onChangeShippingMethod(shippingMethod) {
        this.loading = true;

        this.$store.dispatch('cart/changeShippingMethod', {
          shipmentId: this.shipment._id,
          wishlistId: this.wishlistId,
          value: shippingMethod
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          this.$alert(error.general || 'An error occurred. Please wait a moment before trying again.');
        });
      }
    }
  };
</script>
